import React from 'react'
import styled from 'styled-components'

const Impressum = ({ className }) => {
  return (
    <div className={className}>
      <div className="wrapper">
      </div>
      <div className="content">
        <h1>{`Impressum & Privacy Policy`}</h1>

        <h2>Who is the publisher?</h2>
        Jungle Program GmbH <br />
        Zehdenicker Str. 14 <br />
        10119 Berlin <br />
        Germany <br />
        <br />
        contact (at) jungleprogram.com<br />
        <br />
        Trade Registry Number: HRB 205965, Berlin Charlottenburg<br />
        VAT ID: DE323281324<br />
        Tax ID: 30/369/50192<br />
        <br />
        General Management: Louis Rouffineau, Gautier Roquancourt.<br />

        <h2>How do you handle cookies, trackers and personal data?</h2>
        In order to comply with the General Data Protection Regulations (GDPR) we have chosen not to collect personal
        data or track behaviour on our site :

        <ul>
          <li>
            The email address and personnal data are collected in case of a job posting or a member application to Jungle Program.
            This email and personnal data will only be used in the cases specified during registration and will not be transmitted to any third party.
          </li>
          <li>
            We do not collect information from social media sharing tools (but these third party tools may collect data if you are browsing with an open session / have not logged out);
          </li>
          <li>
            No identification or tracking cookies are used, the only cookies used are those that enable the proper functioning of the site;
          </li>
          <li>
            The tracking of the frequentation of the site is done via a self-hosted instance of Matomo Analytics with anonymization of the collected data. If our logs keep track of the IP addresses collected, they are truncated before being processed.
          </li>
          <li>
            We have no other trackers (advertising, retargeting etc…).
          </li>
          <li>
            The site does not require prior cookie consent. Learn more on <a href="https://matomo.org/faq/new-to-piwik/how-do-i-use-matomo-analytics-without-consent-or-cookie-banner/" target="_blank" rel="noreferrer nofollow">how we use Matomo Analytics without consent</a>.
          </li>
        </ul>

        <h2>Credits</h2>
        We display images and graphic elements provided by several platforms. Each platform has a set of licences under which
        they distribute and allow us to use those graphic elements on our website and communication:

        <ul>
          <li>
            <a href="https://www.pexels.com/license/" rel="nofollow noopener noreferrer" target="_blank" className="external-link">
              Pexels Licence
            </a>
          </li>
          <li>
            <a href="https://unsplash.com/licenseUnsplash" rel="nofollow noopener noreferrer" target="_blank" className="external-link">
              Unsplash Licence
            </a>
          </li>
          <li>
            Figma Community, licenced under <a href="https://creativecommons.org/licenses/by/4.0/" rel="nofollow noopener noreferrer" target="_blank" className="external-link">CC BY 4.0</a>
            &nbsp;and <a href="https://www.figma.com/community-resource-license/" rel="nofollow noopener noreferrer" target="_blank" className="external-link">Community Resource License</a>
          </li>
          <li>
            <a href="https://ui8.net/licensing" rel="nofollow noopener noreferrer" target="_blank" className="external-link">
              UI8 Licence
            </a>
          </li>
        </ul>

      </div>
    </div>
  )
}

const StyledImpressum = styled(Impressum)`
  width: 100%;

  .wrapper {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto; 
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .content {
    max-width: 950px;
    padding: 60px;
    margin: 0 auto;
    line-height: 1.4;
  }

  h1 {
    font-family: 'Tomato Grotesk';
    font-weight: 600;
    font-size: 45px;
    color: #000;
    letter-spacing: 0px;
    text-align: center;
    margin-bottom: 60px;
  }

  h2 {
    font-family: 'Tomato Grotesk';
    font-weight: 400;
    margin: 30px 0;
  }

  ul {
    list-style: disc;
  }

  ol, ul {
    margin: 1em 0 0 1.5em;
  }

  li {
    padding: 8px 0;
  }
`

export default StyledImpressum